var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYidu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.32a.5.5 0 01.29-.454l6-2.77a.5.5 0 01.42 0l6 2.77a.5.5 0 01.29.454v8.18a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5V5.32z",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5l5.642 2.821a.8.8 0 00.716 0L14 5",
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_yidu.e03fcf32.svg";
export { SvgTongyongYidu as ReactComponent };